var exports = {
  "p": "PricingPlans--gridline__44DfRd",
};

module.exports = exports;
